import { theme, useThemeMode } from "@meiden-connect/ui";
import { useEffect, type ReactNode } from "react";
import { loadDashboardThemePreference } from "../../theme/theme-preference";
import { DashboardFooter } from "./dashboard-footer";
import { DashboardHeader } from "./dashboard-header";

export function DashboardShell({ children }: { readonly children: ReactNode }): JSX.Element {
  const themeMode = useThemeMode();

  useEffect(() => {
    theme.setPreference(loadDashboardThemePreference());
  }, []);

  return (
    <div className="dashboard-shell" data-dashboard-theme-mode={themeMode}>
      <DashboardHeader />
      <main className="dashboard-main">{children}</main>
      <DashboardFooter />
    </div>
  );
}
